import React from 'react';
import PropTypes from 'prop-types';
import { PetIcon } from '../../petIcon/petIcon';
import { GetPetDetailsFromPolicyNumber } from '../../../helpers/petHelpers';
import { PetsTreatedPropTypes } from '../../../propTypes/vetDetails';
import { FullPetDetailsPropTypes } from '../../../propTypes/petDetails';
import { formatDate } from '../../../helpers/vetHelpers';

export const PetsTreatedList = ({ petDetails, petsTreated }) => {
  return (
    <div className="petsTreatedList">
      <h4>PET</h4>
      <ul>
        {petsTreated?.map((pet) => {
          const { PetName, PolicyNumber, FromDate, ToDate } = pet;

          const { Species, FullPolicyNumber, PetProfilePicture, PolicyDetails } = GetPetDetailsFromPolicyNumber({
            petDetails,
            policyNumber: PolicyNumber
          });

          const { PetGender } = PolicyDetails;

          const formattedFromDate = formatDate(FromDate) ? `${formatDate(FromDate)}  - ` : '';
          const formattedToDate = formatDate(ToDate) || 'Ongoing';

          return (
            <li key={PolicyNumber}>
              <PetIcon
                profilePic={PetProfilePicture}
                fullPolicyNumber={FullPolicyNumber}
                gender={PetGender}
                species={Species}
              />
              <span className="petName">{PetName}</span>
              <span className="datesVisited">
                {formattedFromDate} {formattedToDate}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

PetsTreatedList.propTypes = {
  petDetails: PropTypes.arrayOf(FullPetDetailsPropTypes),
  petsTreated: PetsTreatedPropTypes
};
